import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-gray container-fix-padding" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = { class: "text-h5 mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "coupon-success"
}
const _hoisted_5 = {
  key: 1,
  class: "fail"
}
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = { class: "input-group-btn" }
const _hoisted_8 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_9 = { class: "fw-bold fs-3" }

import { ref, computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Course from '../../../api/v2/models/course'
import TermInUse from '../atoms_molecules/TermInUse.vue'
import { Card, createToken } from 'vue-stripe-elements-plus'
import api from '../../../api/v2/api'
import { ROUTER_NAME } from '../../router'
import { userState } from '../../stores/user'


export default /*@__PURE__*/_defineComponent({
  __name: 'CoursePurchase',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const user = computed(() => userState.user)
const course = ref<Course | null>(null)
const hasAgreed = ref(false)
const hasInstallment = ref(false)
const currentInstallment = ref(1)
const complete = ref(false)
const canClick = ref(true)
const isShowSuccess = ref(false)
const isShowFail = ref(false)
const getDiscount = ref("")
const couponCode = ref("")
const purchasePrice = ref(0)
const stripePublishableKey = ref("")

const breadcrumbItems = ref([
  {
    text: 'コース一覧',
    disabled: false,
    exact: true,
    to: '/classroom/courses'
  }
])

const getCoupon = async () => {
  try {
    const coupon = await api.coursePurchase.getCoupon(parseInt(route.params.courseId as string), { couponCode: couponCode.value })
    if (coupon) {
      getDiscount.value = `- ${coupon.discountPrice.toLocaleString()}円`
      purchasePrice.value = coupon.purchaseDiscountPrice
      isShowSuccess.value = true
      isShowFail.value = false
    }
  } catch (e) {
    getDiscount.value = ""
    purchasePrice.value = course.value!.purchasePrice
    isShowSuccess.value = false
    isShowFail.value = true
  }
}

const purchase = async () => {
  canClick.value = false
  try {
    const tokenResponse = await createToken()
    await api.coursePurchase.create(
      route.params.courseId as string, {
        stripeToken: tokenResponse.token.id,
        installmentCount: hasInstallment.value ? currentInstallment.value : 1
      })
    router.push({
      name: ROUTER_NAME.MY_COURSE_DETAIL,
      params: {
        courseId: course.value!.id.toString()
      }
    })
  } catch (e) {
  } finally {
    canClick.value = true
  }
}

const cancelCoupon = () => {
  getDiscount.value = ""
  purchasePrice.value = course.value!.purchasePrice
  isShowSuccess.value = false
  isShowFail.value = false
  couponCode.value = ""
}

const checkPurchaseNecessary = async () => {
  if (user.value) {
    try {
      const coursePurchase = await api.coursePurchase.show_by_course(route.params.courseId as string)
      if ((Boolean(coursePurchase) && Boolean(Object.keys(coursePurchase).length)) || (user.value.latestSubscription && user.value.latestSubscription.isActive)) {
        return router.push({
          name: ROUTER_NAME.MY_COURSE_DETAIL,
          params: {
            examId: route.params.courseId as string
          }
        })
      }
    } catch (e) {
    }
  }
}

watch(user, () => {
  checkPurchaseNecessary()
})

onMounted(async () => {
  try {
    course.value = await api.course.show(route.params.courseId as string)
    purchasePrice.value = course.value.purchasePrice
    breadcrumbItems.value.push({
      text: course.value.name,
      disabled: false,
      exact: true,
      to: `/classroom/courses/${course.value.id}`
    })
  } catch (e) {
  }
})

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (course.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_AppBreadcrumb, { items: breadcrumbItems.value }, null, 8 /* PROPS */, ["items"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_col, { lg: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_3, _toDisplayString(course.value.name) + "を購入する【" + _toDisplayString(course.value.price.toLocaleString()) + "円 + 税金" + _toDisplayString(course.value.purchaseTax.toLocaleString()) + "円 " + _toDisplayString(getDiscount.value) + "= " + _toDisplayString(purchasePrice.value.toLocaleString()) + "円】", 1 /* TEXT */),
                (course.value.price > 0 && course.value.isUseCoupon)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", null, "クーポン", -1 /* CACHED */)),
                      _createElementVNode("div", null, [
                        (isShowSuccess.value)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_4, "クーポンを使用しています。"))
                          : _createCommentVNode("v-if", true),
                        (isShowFail.value)
                          ? (_openBlock(), _createElementBlock("label", _hoisted_5, "クーポンが無効になっていますので、再度確認ください"))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((couponCode).value = $event)),
                          class: "form-control"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, couponCode.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (getCoupon())),
                          class: "form-control"
                        }, "適用"),
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (cancelCoupon())),
                          class: "form-control"
                        }, "キャンセル")
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true),
                _cache[9] || (_cache[9] = _createElementVNode("p", null, "下記の受講規約をご確認いただき、同意の上お申込みください。", -1 /* CACHED */)),
                _createVNode(TermInUse),
                _createVNode(_component_v_checkbox, {
                  modelValue: hasAgreed.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((hasAgreed).value = $event)),
                  label: "受講規約に同意します",
                  "hide-details": ""
                }, null, 8 /* PROPS */, ["modelValue"]),
                (hasAgreed.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (course.value.canInstallment)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_v_checkbox, {
                              modelValue: hasInstallment.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((hasInstallment).value = $event)),
                              label: "分割払い",
                              "hide-details": ""
                            }, null, 8 /* PROPS */, ["modelValue"]),
                            (hasInstallment.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                  _createVNode(_component_v_text_field, {
                                    style: {"width":"200px"},
                                    modelValue: currentInstallment.value,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentInstallment).value = $event)),
                                    label: "分割払い回数",
                                    type: "number",
                                    min: "1",
                                    max: course.value.installmentCount
                                  }, null, 8 /* PROPS */, ["modelValue", "max"]),
                                  _createElementVNode("div", _hoisted_9, " 1回 / " + _toDisplayString(Math.round( purchasePrice.value / currentInstallment.value ).toLocaleString()) + "円 ", 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true),
                      _createVNode(_unref(Card), {
                        class: _normalizeClass([{ 'complete': complete.value }, "stripe-card my-5"]),
                        options: {
                hidePostalCode: true
              },
                        stripe: course.value.stripePublishableKey,
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (complete.value = $event.complete))
                      }, null, 8 /* PROPS */, ["class", "stripe"]),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        dark: "",
                        onClick: purchase,
                        disabled: !canClick.value
                      }, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("カード決済する", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled"])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            })
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})